
window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
/*
//using socket.io and redis
window.io = require('socket.io-client');
window.Echo = new Echo({
    broadcaster: 'socket.io',
    authEndpoint: 'https://admin.reach-ats.com:6001/broadcasting/auth',
    //host: 'https://' window.location.hostname ':6001'
    host:'https://admin.reach-ats.com:6001'
});
*/

import Pusher from 'pusher-js';
window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'reverb', //reverb uses the pusher protocol, but this is a custom driver in broadcasing.php
    key:        process.env.MIX_REVERB_APP_KEY,
    cluster:    process.env.MIX_REVERB_APP_CLUSTER || 'mt1',
    wsHost:     process.env.MIX_REVERB_HOST,
    wsPort:     process.env.MIX_REVERB_PORT,
    wssPort:    process.env.MIX_REVERB_PORT,
    forceTLS: process.env.MIX_REVERB_SCHEME === 'https', //true if using https
    encrypted:  true,
    disableStats: true,
    enabledTransports: ['ws','wss']
});
